import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';

import SmsAPI from '../../api/SmsAPI';
import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Const from '../../util/Constants';

class InnerSmsList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).sms;
    this.state = { inApiCall: true, smses: [] };

    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() { this.loadSmses(this.props.id); }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, smses: [] });
      this.loadSmses(props.id);
    }
  }

  loadSmses = id => { SmsAPI.getInnerList(this.props.type, id, this.onReceived, this.onFail); };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    if (this.props.onCount) {
      this.props.onCount('sms', res.count);
    }
    this.setState({ inApiCall: false, smses: res.data });
  };
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      SmsAPI.delete(this.state.smses[indx].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'SMS deleted successfully', 'success');
    this.props.reload();
  };

  showList = () => this.state.smses.map((sms, _i) => (
    <tr key={`sms_${_i + 1}`}>
      <td>{Util.serverStringToDisplayDateTime(sms.created_date)}</td>
      <td>{Display.FieldValue(sms, 'type', this.model.fields)}</td>
      <td>{Display.FieldValue(sms, 'phone', this.model.fields)}</td>
      <td>{Display.ModelLabelValue('user', sms.created_by)}</td>
      <td>{Display.FieldValue(sms, 'text', this.model.fields)}</td>
      <td>{Display.FieldValue(sms, 'response', this.model.fields)}</td>
      {/*
      <td>
        { this.Delete &&
          <span onClick={() => this.onDelete(_i)} className="buttons delete"><FaTrash /> Delete</span>
        }
      </td>
      */}
    </tr>
  ));

  render() {
    let uiSmses = this.showList();
    if (this.state.smses.length === 0) uiSmses = <tr><td colSpan="6">No Records Found</td></tr>;
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>SMS</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover size='sm'>
              <thead>
                <tr>
                  <th>Date Time</th>
                  <th>Type</th>
                  <th>Phone</th>
                  <th>Sales Person</th>
                  <th>Text</th>
                  <th>Response</th>{
                  /*<th className="actionth">Action</th>*/}
                </tr>
              </thead>
              <tbody>
                {uiSmses}
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default InnerSmsList;